import axios from 'axios'

const state = {
    portalLookup: null,
    setMarketers: null,
    setMktReferrals: null,
}

const getters = {
    portalLookup (state) {
        return state.portalLookup
    },
    setMarketers (state) {
        return state.setMarketers
    },
    setMktReferrals (state) {
        return state.setMktReferrals
    }
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async portalSearchUsers({ _ }, searchObj) { 
        let response = await axios.post('/search/searchUserHandle', searchObj)
        return response.data
    },

    async portalLookupUser({ commit }, userObj) {
        commit('SET_PORTAL_LOOKUP', null)
        let response = await axios.post(`/portal/fetchPortalUser`, userObj)
        if(!response.data.error){
            commit('SET_PORTAL_LOOKUP', response.data.result)
        }
        return response.data
    },
    
    async fetchMarketers({ commit }, stateRepsObj) {
        commit('SET_MARKETERS', null)
        let response = await axios.post(`/portal/fetchMyMarketers`, stateRepsObj)
        if(!response.data.error){
            return commit('SET_MARKETERS', response.data.result)
        }
        return response.data
    },
    
    async fetchMktReferrals({ commit }, marketerObj) {
        commit('SET_MKT_REFERRALS', null)
        let response = await axios.post(`/portal/fetchMyReferrals`, marketerObj)
        if(!response.data.error){
            return commit('SET_MKT_REFERRALS', response.data.result)
        }
        return response.data
    },
    
    async addMarketer({ dispatch }, marketerObj) {
        let response = await axios.post(`/portal/newMarketer`, marketerObj)
        if(!response.data.error){
            dispatch('attempt', localStorage.getItem('_m12tk10q')) // relog user in to fetch updated roles
            dispatch('portalLookupUser', marketerObj) // note: userId here is the new marketerId
        }
        return response.data
    },
    
    async removeMarketer({ _ }, marketerObj) {
        let response = await axios.post(`/portal/delMarketer`, marketerObj)
        return response.data
    }
}

const mutations = {
    SET_MARKETERS: (state, setMarketers) => (state.setMarketers = setMarketers),
    SET_PORTAL_LOOKUP: (state, portalLookup) => (state.portalLookup = portalLookup),
    SET_MKT_REFERRALS: (state, setMktReferrals) => (state.setMktReferrals = setMktReferrals),
}

export default {
    state,
    getters,
    actions,
    mutations
}